import { InvestorName } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/InvestorName';
import { PersonHoverInfo } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/PersonHoverInfo';
import { InvestmentProgrammeDocumentRes } from '@dealstack/shared/lib/generated';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { ActionIcon, Flex, Text } from '@mantine/core';
import { useMemo, useState } from 'react';
import { BadgeContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/BadgeContainer';

const MAX_VISIBLE_INVESTORS = 5;

interface Props {
	investors: InvestmentProgrammeDocumentRes['investor'];
}

export const InvestorsDropdown = ({ investors }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const [visibleInvestors, hiddenInvestors] = useMemo(() => {
		if (investors.length > MAX_VISIBLE_INVESTORS) {
			return [
				investors.slice(0, MAX_VISIBLE_INVESTORS),
				investors.slice(MAX_VISIBLE_INVESTORS),
			];
		}
		return [investors, []];
	}, [investors]);

	return (
		<Flex gap="xs" align="center">
			<ActionIcon
				size="xs"
				onClick={(e) => {
					e.stopPropagation();
					setIsOpen(!isOpen);
				}}
			>
				<Icon
					size="lg"
					variant={isOpen ? 'caret-down' : 'caret-right'}
					color={defaultTheme.v3.colors.black[0]}
				/>
			</ActionIcon>
			{!isOpen && (
				<Flex gap="0.25rem" wrap="wrap">
					{visibleInvestors.map((investor) =>
						investor.status != null ? (
							<PersonHoverInfo
								key={`${investor.firstName}-${investor.lastName}`}
								person={investor}
							/>
						) : (
							<InvestorName
								key={`${investor.firstName}-${investor.lastName}`}
								investor={investor}
							/>
						)
					)}
					{hiddenInvestors.length > 0 && (
						<BadgeContainer align="center" justify="center">
							<Text>+ {hiddenInvestors.length}</Text>
						</BadgeContainer>
					)}
				</Flex>
			)}
			{isOpen && (
				<Flex direction="column" gap="0.25rem">
					{investors.map((investor) => (
						<InvestorName
							key={`${investor.firstName}-${investor.lastName}`}
							investor={investor}
						/>
					))}
				</Flex>
			)}
		</Flex>
	);
};
